import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import classNames from "classnames";
import React, { useState } from "react";
import MultiAxisLineChart from "shared/components/lineGraph";
import RangeDatePicker from "shared/components/rangeDatePicker";
import styles from "./style.module.scss";

interface GraphPlansGridProps {
  activeTab: any;
}

let tabsEnums = {
  parents: 1,
  kids: 2,
  school: 3,
};

function GraphPlansGrid({ activeTab }: GraphPlansGridProps) {
  const [startDate, setStartDate] = useState<Date | null>(null);
  const [endDate, setEndDate] = useState<Date | null>(new Date());

  let dataSetsForGraphs = [
    {
      label: "Monthly Plan",
      data: [
        "10",
        "15",
        "20",
        "25",
        "30",
        "35",
        "40",
        "45",
        "50",
        "55",
        "60",
        "100",
        "200",
        "300",
        "400",
        "500",
        "600",
        "700",
        "800",
        "900",
        "750",
        "650",
        "550",
        "450",
        "350",
        "250",
        "150",
        "50",
      ],
      borderColor: "#9A469B",
      backgroundColor: "#9A469B",
      pointRadius: 5,
      pointHoverRadius: 7,
      pointBorderColor: "rgba(0, 0, 0, 0)",
      pointBackgroundColor: "rgba(0, 0, 0, 0)",
      pointHoverBackgroundColor: "#9A469B",
      pointHoverBorderColor: "#FFFFFF",
    },
    {
      label: "Annual Plan",
      data: [
        "5",
        "10",
        "15",
        "20",
        "30",
        "40",
        "50",
        "60",
        "70",
        "80",
        "100",
        "780",
        "300",
        "800",
        "500",
        "600",
        "400",
        "800",
        "450",
        "950",
        "800",
        "700",
        "600",
        "500",
        "400",
        "300",
        "200",
        "100",
      ],
      borderColor: "#EF437B",
      backgroundColor: "#EF437B",
      pointRadius: 5,
      pointHoverRadius: 7,
      pointBorderColor: "rgba(0, 0, 0, 0)",
      pointBackgroundColor: "rgba(0, 0, 0, 0)",
      pointHoverBackgroundColor: "#EF437B",
      pointHoverBorderColor: "#FFFFFF",
    },
    {
      label: "3 Months Plan",
      data: [
        "8",
        "16",
        "24",
        "32",
        "40",
        "48",
        "56",
        "64",
        "72",
        "400",
        "100",
        "250",
        "800",
        "550",
        "700",
        "850",
        "500",
        "880",
        "920",
        "900",
        "980",
        "800",
        "700",
        "600",
        "500",
        "400",
        "300",
        "200",
      ],
      borderColor: "#1897A6",
      backgroundColor: "#1897A6",
      pointRadius: 5,
      pointHoverRadius: 7,
      pointBorderColor: "rgba(0, 0, 0, 0)",
      pointBackgroundColor: "rgba(0, 0, 0, 0)",
      pointHoverBackgroundColor: "#1897A6",
      pointHoverBorderColor: "#FFFFFF",
    },
  ];

  return (
    <div className={styles.mainContainer}>
      <div className={styles.headingContainer} style={{ padding: "19px 24px" }}>
        <div className={styles.analyticsHeading}>
          Membership Plans Sales Analytics of
          {activeTab === tabsEnums.kids
            ? " Kids"
            : activeTab === tabsEnums.parents
            ? " Parents"
            : activeTab === tabsEnums.school
            ? " Schools"
            : ""}
        </div>
        <div>
          <RangeDatePicker
            startDate={startDate}
            setStartDate={setStartDate}
            endDate={endDate}
            setEndDate={setEndDate}
            labelStyle={styles.dateLabel}
          />
        </div>
      </div>
      <div className={styles.graphMainContainer}>
        <div className={styles.headingContainer} style={{ padding: "16px" }}>
          <div
            className={classNames(
              styles.analyticsHeading,
              styles.colorDarkPurple
            )}
          >
            Active Membership Plans
          </div>
          <div>
            <FilterMenu />
          </div>
        </div>
        <div className={styles.graphContainer}>
          <MultiAxisLineChart
            datasets={dataSetsForGraphs}
            legend={false}
            canvasStyle={styles.canvas}
            responsive={false}
            labels={[
              "1",
              "2",
              "3",
              "4",
              "5",
              "6",
              "7",
              "8",
              "9",
              "10",
              "11",
              "12",
              "13",
              "14",
              "15",
              "16",
              "17",
              "18",
              "19",
              "20",
              "21",
              "22",
              "23",
              "24",
              "25",
              "26",
              "27",
              "28",
            ]}
          />
        </div>
      </div>
    </div>
  );
}

export default GraphPlansGrid;

function FilterMenu() {
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);
  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <div>
      <button
        id="basic-button"
        aria-controls={open ? "basic-menu" : undefined}
        aria-haspopup="true"
        aria-expanded={open ? "true" : undefined}
        onClick={handleClick}
        style={{
          background: "transparent",
          border: "none",
          display: "flex",
          alignItems: "center",
          cursor: "pointer",
        }}
        className={styles.filterBtn}
      >
        <span
          className={classNames(styles.filterLabel)}
          style={{ textTransform: "none" }}
        >
          Apply Filter
        </span>{" "}
        <KeyboardArrowDownIcon sx={{ color: "#9a469b" }} />
      </button>
      <Menu
        id="basic-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        MenuListProps={{
          "aria-labelledby": "basic-button",
        }}
        PaperProps={{
          sx: {
            boxShadow: "none",
            border: "1px solid #e2e2e2",
            padding: "0px 10px",
          },
        }}
      >
        <MenuItem onClick={handleClose}>Filter 1</MenuItem>
        <MenuItem onClick={handleClose}>Filter 2</MenuItem>
        <MenuItem onClick={handleClose}>Filter 3</MenuItem>
      </Menu>
    </div>
  );
}
